(() => {
  function parseData(root) {
    try {
      return JSON.parse(root.querySelector('[data-rh-u-data]')?.textContent || '{}');
    } catch (error) {
      console.error('Sticky offer data could not be read', error);
      return null;
    }
  }

  function initialize(root) {
    if (root.dataset.rhUnifiedInitialized === 'true') return;
    const data = parseData(root);
    const nativeBar = root.closest('[data-sticky-add-to-cart]');
    if (!data?.variants?.length || !nativeBar) return;

    const productId = String(root.dataset.productId || '');
    const nativeVariant = nativeBar.querySelector(`#stick-variant-${productId}, variant-sticky-selects select`);
    const nativeAdd = nativeBar.querySelector('#product-sticky-add-to-cart');
    const optionSelects = Array.from(root.querySelectorAll('[data-rh-u-option]'));
    const isMini4 = productId === '8906665296049';
    const packageIndex = isMini4 ? 0 : data.options.findIndex((name) => /^(select option|package|your setup)$/i.test(name));
    const conditionIndex = isMini4 ? 1 : data.options.findIndex((name) => /^(cosmetic condition|condition)$/i.test(name));
    const count = root.querySelector('.rh-u-count');
    const minus = root.querySelector('[data-rh-u-delta="-1"]');
    const plus = root.querySelector('[data-rh-u-delta="1"]');
    const was = root.querySelector('.rh-u-was');
    const saving = root.querySelector('.rh-u-saving');
    const percent = root.querySelector('.rh-u-percent');
    const now = root.querySelector('.rh-u-now');
    const packageName = root.querySelector('.rh-u-package');
    const condition = root.querySelector('.rh-u-condition');
    const cta = root.querySelector('.rh-u-cta');
    const ctaLabel = root.querySelector('.rh-u-cta-label');
    let current = data.variants.find((variant) => String(variant.id) === String(nativeVariant?.value || data.initialId)) || data.variants[0];
    let quantity = 1;

    const formatMoney = (cents) => new Intl.NumberFormat(data.locale || 'en-US', {
      style: 'currency',
      currency: data.currency || 'USD',
    }).format(Number(cents || 0) / 100);

    const rule = () => ({
      min: Math.max(1, Number(current.quantityRule?.min) || 1),
      max: Number(current.quantityRule?.max) > 0 ? Number(current.quantityRule.max) : Infinity,
      increment: Math.max(1, Number(current.quantityRule?.increment) || 1),
    });

    const normalizeQuantity = (value) => {
      const limits = rule();
      const requested = Number(value);
      const stepped = limits.min + Math.round((Math.max(limits.min, requested || limits.min) - limits.min) / limits.increment) * limits.increment;
      return Math.min(limits.max, stepped);
    };

    const quantityInputs = () => Array.from(document.querySelectorAll([
      `#product-form-${productId} input[name="quantity"]`,
      `#product-form-sticky-${productId} input[name="quantity"]`,
    ].join(',')));

    const variantInputs = () => Array.from(document.querySelectorAll([
      `#product-form-${productId} input[name="id"]`,
      `#product-form-installment-${productId} input[name="id"]`,
      `#product-form-sticky-${productId} input[name="id"]`,
    ].join(',')));

    function syncNativeQuantity() {
      quantityInputs().forEach((input) => {
        if (String(input.value) === String(quantity)) return;
        input.value = String(quantity);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    function syncNativeVariant() {
      variantInputs().forEach((input) => {
        if (String(input.value) === String(current.id)) return;
        input.value = String(current.id);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (nativeVariant && String(nativeVariant.value) !== String(current.id)) {
        nativeVariant.value = String(current.id);
        nativeVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function render() {
      quantity = normalizeQuantity(quantity);
      optionSelects.forEach((select) => {
        const optionIndex = Number(select.dataset.rhUOption);
        if (select.value !== current.options[optionIndex]) select.value = current.options[optionIndex];
      });
      const discounted = Number(current.compare) > Number(current.price);
      const totalPrice = Number(current.price) * quantity;
      const totalCompare = Number(current.compare) * quantity;
      was.hidden = !discounted;
      saving.hidden = !discounted;
      was.textContent = discounted ? formatMoney(totalCompare) : '';
      percent.textContent = discounted ? String(Math.round((1 - Number(current.price) / Number(current.compare)) * 100)) : '';
      now.textContent = formatMoney(totalPrice);
      const selectedOptionText = (index, fallback) => optionSelects.find((select) => Number(select.dataset.rhUOption) === index)?.selectedOptions?.[0]?.textContent?.trim() || fallback;
      packageName.textContent = packageIndex >= 0 ? selectedOptionText(packageIndex, current.options[packageIndex]) : current.title;
      condition.textContent = conditionIndex >= 0 ? selectedOptionText(conditionIndex, current.options[conditionIndex]) : '';
      condition.hidden = conditionIndex < 0;
      count.textContent = String(quantity);
      const limits = rule();
      minus.disabled = quantity <= limits.min;
      plus.disabled = quantity >= limits.max;
      cta.disabled = !current.available;
      ctaLabel.textContent = current.available ? data.addLabel : data.soldLabel;
      cta.setAttribute('aria-label', current.available
        ? `${data.addLabel}: ${quantity} × ${packageName.textContent}, ${condition.textContent}, ${now.textContent}`
        : `${packageName.textContent}, ${condition.textContent}: ${data.soldLabel}`);
      syncNativeVariant();
      syncNativeQuantity();
    }

    function selectVariant(options) {
      const match = data.variants.find((variant) => variant.options.every((value, index) => value === options[index]));
      if (!match) return;
      current = match;
      render();
    }

    optionSelects.forEach((select) => select.addEventListener('change', () => {
      const options = current.options.slice();
      options[Number(select.dataset.rhUOption)] = select.value;
      selectVariant(options);
    }));

    root.querySelectorAll('[data-rh-u-delta]').forEach((button) => button.addEventListener('click', () => {
      quantity = normalizeQuantity(quantity + Number(button.dataset.rhUDelta) * rule().increment);
      render();
    }));

    nativeVariant?.addEventListener('change', () => {
      const match = data.variants.find((variant) => String(variant.id) === String(nativeVariant.value));
      if (!match || String(match.id) === String(current.id)) return;
      current = match;
      render();
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.name !== 'quantity') return;
      if (!input.closest(`#product-form-${CSS.escape(productId)}, #product-form-sticky-${CSS.escape(productId)}`)) return;
      const next = normalizeQuantity(input.value);
      if (next === quantity) return;
      quantity = next;
      render();
    });

    cta.addEventListener('click', () => {
      if (!current.available || !nativeAdd) return;
      syncNativeVariant();
      syncNativeQuantity();
      nativeAdd.click();
    });

    root.dataset.rhUnifiedInitialized = 'true';
    root.dataset.single = String(Boolean(data.single));
    root.hidden = false;
    nativeBar.setAttribute('data-rh-unified-ready', '');
    render();
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-rh-offer]').forEach(initialize);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
